var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { connect } from 'react-redux';
import { get, reduce, defaults, clone, map } from 'lodash';
import { createSelector } from 'reselect';
import { Form, getField } from '../form';
import { actions } from '@comall-backend-builder/core';

var getComponentId = function getComponentId(_state, props) {
  return props.componentId;
};

var getComponentState = function getComponentState(state, props) {
  return state.components[props.componentId];
};

var getEntityId = function getEntityId(_state, props) {
  return props.entity.id;
};

var getEntityMetainfo = function getEntityMetainfo(_state, props) {
  return props.entity.metainfo;
};

var getEntityRequestStatus = function getEntityRequestStatus(_state, props) {
  return props.entity.requestStatus;
}; // 从组件中获取的表单域集合


var getFieldsConfig = function getFieldsConfig(_state, props) {
  return props.fields;
};

var makeGetFormState = function makeGetFormState() {
  return createSelector([getComponentId, getComponentState, getEntityId, getEntityMetainfo, getEntityRequestStatus, getFieldsConfig], function (componentId, componentState, entityId, metainfo, requestStatus, fieldsFromProps) {
    if (componentState === void 0) {
      componentState = {};
    }

    var _a = componentState.fields,
        fieldValues = _a === void 0 ? {} : _a,
        _b = componentState.status,
        status = _b === void 0 ? {} : _b,
        submitType = componentState.submitType;
    var properties = metainfo.properties; // 未配置表单域

    if (!fieldsFromProps) {
      throw new Error("Fields not found in Component " + componentId);
    }

    var fields = {};
    map(fieldsFromProps, function (_a) {
      var fieldProperty = _a.property,
          fieldConfig = __rest(_a, ["property"]); // 校验配置项是否与实体属性匹配，实体中的 path 为 style.properties.color，配置中 path 为 style.color


      var entityPropertyPath = fieldProperty.replace(/\./g, '.properties.');
      var propery = get(properties, entityPropertyPath);

      if (!propery) {
        throw new Error("Property " + fieldProperty + " not found in Entity " + entityId);
      }

      var fieldNames = []; // 需要处理嵌套表单

      var parent = properties;
      var currentFields = fields;

      for (var _i = 0, _b = fieldProperty.split('.'); _i < _b.length; _i++) {
        var propertyName = _b[_i];
        var entityProperty = parent[propertyName];
        fieldNames.push(propertyName);
        var fieldName = fieldNames.join('.');

        if (entityProperty.type === 'object.subForm') {
          if (!currentFields[fieldName]) {
            currentFields[fieldName] = __assign(__assign({}, entityProperty), {
              fields: {},
              value: get(fieldValues, fieldName)
            });
          }

          currentFields = currentFields[fieldName].fields;
        } else {
          currentFields[fieldName] = __assign(__assign(__assign({}, entityProperty), fieldConfig), {
            value: get(fieldValues, fieldName),
            status: status[fieldName]
          });
        }

        parent = entityProperty.properties;
      }
    });
    return {
      fields: fields,
      requestStatus: requestStatus,
      submitType: submitType,
      fieldValues: fieldValues
    };
  });
};

function makeMapStateToProps(_state, _props) {
  var getFormState = makeGetFormState();
  return function (state, props) {
    return {
      state: getFormState(state, props)
    };
  };
}

function mapDispatchToProps(dispatch, props) {
  var componentId = props.componentId,
      entity = props.entity,
      onFieldChange = props.onFieldChange,
      onReloadOptions = props.onReloadOptions,
      onSubmitStart = props.onSubmitStart;
  return defaults({
    onFieldChange: onFieldChange,
    onReloadOptions: onReloadOptions,
    onSubmitStart: onSubmitStart
  }, {
    // 表单域改变
    onFieldChange: function onFieldChange(name, value) {
      dispatch(actions.formChangeAction(componentId, name, value));
    },
    // 表单域状态改变
    onFieldStatusChange: function onFieldStatusChange(name, status) {
      dispatch(actions.formStatusChangeAction(componentId, name, status));
    },
    // 重新加载属性候选值
    onReloadOptions: function onReloadOptions(fieldName, fields) {
      var field = getField(fieldName, fields);
      var sourceDefination = field.source;
      var dependences = sourceDefination.dependences;
      var params = reduce(dependences, function (values, dependence) {
        values[dependence] = getField(dependence, fields).value;
        return values;
      }, props.params ? clone(props.params) : {});
      entity.loadPropertyOptions(fieldName, sourceDefination, params);
    },
    // 提交表单开始
    onSubmitStart: function onSubmitStart() {
      dispatch(actions.componentSubmitAction(componentId, 'submit'));
    },
    // 提交表单结束
    onSubmitFinish: function onSubmitFinish() {
      dispatch(actions.componentSubmitFinishAction(componentId));
    }
  });
}

export var DataForm = connect(makeMapStateToProps, mapDispatchToProps)(Form);